var map = {
	"./facebook.svg": 78705,
	"./instagram.svg": 88804,
	"./linkedin.svg": 73071,
	"./telegram.svg": 77852,
	"./tiktok.svg": 44718,
	"./twitter.svg": 51859,
	"./youtube.svg": 12100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93070;